import React from 'react'
import { ClientTypeTitle } from '../../../../../../constants/ClientTypes'
import CustomButton from '../../../../CustomButton'
import './style.sass'

const RemoveClientButton = ({ clientType, onRemoveClientClicked, disabled }) => {
  const clientTypeTitle = ClientTypeTitle(clientType)

  return (
    <div className="remove-client-button-container">
      <p>You have added a <b>{clientTypeTitle}</b> client, would you like to remove it?</p>
      <CustomButton
        onClick={onRemoveClientClicked}
        buttonText={`Remove ${clientTypeTitle} client`}
        className={`btn btn-error-outline`}
        disabled={disabled}
      />
    </div>
  )
}

export default RemoveClientButton
